import { render } from "./eleTrans.vue?vue&type=template&id=4ad03ea4&scoped=true"
import script from "./eleTrans.vue?vue&type=script&lang=js"
export * from "./eleTrans.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad03ea4"]])

export default __exports__